/**
 * Converts a 20 characters unique tag to a display representation for PR editors
 * @param {string} tag
 * @return {string}
 */
export function tagToDisplayER(tag) {
    const nrCharTaken = 8;
    const tagNumber = Number('0x' + tag.slice(-1*nrCharTaken));
    // maximum for random number from tag
    const maxNumber = Number('0x' + 'F'.repeat(nrCharTaken));
    // minimum for random number from tag
    const minNumber = 0;
    // minimum id for a pr uid
    const rangeMin = 10**5;
    // maximum id for a pr uid
    const rangeMax = 10**6;
    const normalizedNumber = Math.round(rangeMin + (tagNumber-minNumber)/(maxNumber - minNumber)*(rangeMax-rangeMin));
    if (normalizedNumber >= rangeMax) {
        return (rangeMax - 1).toString(10);
    } else if (normalizedNumber < rangeMin) {
        return rangeMin.toString(10);
    } else {
        return normalizedNumber.toString(10);
    }
}
